export enum CourseTag {
  Recommended = "akomaps-recommended",
}

export const DefaultMapThumbnail = "https://cpl-media-public.s3.us-east-2.amazonaws.com/default_map_thumbnail.jpg";
